import React, { useState } from "react";
import { Button, Card, Col, Form, Row, Spinner } from "@deere/ux.uxframe-react";
import ClaimList from "./ClaimList";

import { isEqual } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { claimsLoading, getClaims, setSearchText } from "./claimSearchSlice";
import { languageResponseData } from "../Translation/translationSerachSlice";
import { resetClaimState } from "./claimSearchSlice";
/*import {searchText} from "./ClaimSearchSlice";*/

const ClaimSearch = () => {
  const translationsResponse = useSelector(languageResponseData);
  const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
  };

  const dispatch = useDispatch();

  const claimsSearchLoading = useSelector(claimsLoading);

  const [searchType, setSearchType] = useState("ClaimNumber");
  const [pin, setPin] = useState(String(""));
  const [claimNumber, setClaimNumber] = useState(String(""));
  const [inputError, setInputError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSelectSearchType = (event) => {
    dispatch(resetClaimState());
    setSearchType(event.target.value);
    setPin("");
    setClaimNumber("");
    setInputError(false);
    setErrorMessage("");
  };
  const onInputClaimSearchValue = (event) => {
    const trimmedValue = event.target.value
      .replace(/\s/g, "")
      .toUpperCase()
      .trim();
    if (searchType && isEqual(searchType, "ClaimNumber")) {
      dispatch(setSearchText(trimmedValue));
      setClaimNumber(trimmedValue);
      setPin("");
    } else if (searchType && isEqual(searchType, "SerialNumber")) {
      setClaimNumber("");
      setPin(trimmedValue);
    }
  };

  const onSearchClaim = () => {
    const searchObj = {
      searchType: searchType,
      pin: pin,
      claimNumber: claimNumber,
      searchFrom: "claimSearchForm",
    };
    dispatch(getClaims(searchObj));
  };

  const claimSearchDisabled = () => {
    return !(pin || claimNumber);
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (searchType === "ClaimNumber" && !/^\d+$/.test(claimNumber)) {
      setInputError(true);
      setErrorMessage("Please enter a valid claim number.");
    } else {
      setInputError(false);
      setErrorMessage("");
      onSearchClaim();
    }
  };

  return (
    <div>
      <Card>
        <Card.Header>
          <strong>{translate("claimsearch", " Claim Search")}</strong>
        </Card.Header>
        <Card.Body>
          <fieldset>
            <Form onSubmit={onSubmitHandler}>
              <Row>
                <Col>
                  <Form.Group controlId="searchType" className="searchType-dd">
                    <Form.Control
                      name="language"
                      required
                      custom
                      as="select"
                      value={searchType}
                      onChange={onSelectSearchType}
                    >
                      <option value="ClaimNumber">
                        {translate("claim_number", "Claim Number")}
                      </option>
                      <option value="SerialNumber">
                        {translate("pin", "Serial Number")}
                      </option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Control
                    aria-label="Claim Number"
                    maxLength={17}
                    value={searchType === "ClaimNumber" ? claimNumber : pin}
                    onChange={onInputClaimSearchValue}
                    style={{ borderColor: inputError ? "red" : "" }}
                  />
                  {inputError && (
                    <p style={{ color: "red", fontSize: 20 }}>{errorMessage}</p>
                  )}
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    disabled={claimSearchDisabled()}
                    type="submit"
                  >
                    {translate("search", "Search")}
                  </Button>
                </Col>
              </Row>
            </Form>
          </fieldset>
        </Card.Body>
      </Card>
      {claimsSearchLoading && (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <Spinner
            accessibilityLabel="Loading"
            className="uxf-spinner-border-lg"
            animation="border"
          />
        </div>
      )}

      <Card>
        <Card.Header>
          <strong>{translate("claim_history", "Claim History")}</strong>
        </Card.Header>
        <Card.Body>
          <ClaimList searchFrom="ClaimSearchForm" />
        </Card.Body>
      </Card>
    </div>
  );
};

export default ClaimSearch;
